import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, ShieldCheck } from "lucide-react";
import { LOGO_URL } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/admin", { replace: true });
  }, [user, loading]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-5 grain relative">
      <div className="relative z-10 w-full max-w-md bg-card border border-pink-200 rounded-3xl p-10 text-center">
        <img src={LOGO_URL} alt="Metrix" className="h-14 mx-auto mb-8" />
        <div className="h-12 w-12 rounded-2xl gold-gradient flex items-center justify-center mx-auto mb-5"><ShieldCheck size={24} className="text-black" /></div>
        <h1 className="font-display text-2xl text-zinc-900">Admin Panel</h1>
        <p className="text-sm text-zinc-600 mt-2 mb-8">Sign in with your authorized Google account to manage bookings, packages and billing.</p>
        <Button onClick={login} data-testid="google-login-btn" className="w-full gold-gradient text-white font-semibold rounded-full h-12">
          <LogIn size={18} className="mr-2" /> Continue with Google
        </Button>
        <a href="/" className="block text-xs text-zinc-500 hover:text-gold mt-6">← Back to website</a>
      </div>
    </div>
  );
}
